/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmBootstrapFieldMismatchRemediateRequest
 */
export interface MdmBootstrapFieldMismatchRemediateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmBootstrapFieldMismatchRemediateRequest
     */
    configurationIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof MdmBootstrapFieldMismatchRemediateRequest
     */
    remediateAll?: boolean;
}

/**
 * Check if a given object implements the MdmBootstrapFieldMismatchRemediateRequest interface.
 */
export function instanceOfMdmBootstrapFieldMismatchRemediateRequest(value: object): value is MdmBootstrapFieldMismatchRemediateRequest {
    return true;
}

export function MdmBootstrapFieldMismatchRemediateRequestFromJSON(json: any): MdmBootstrapFieldMismatchRemediateRequest {
    return MdmBootstrapFieldMismatchRemediateRequestFromJSONTyped(json, false);
}

export function MdmBootstrapFieldMismatchRemediateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmBootstrapFieldMismatchRemediateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'configurationIds': json['configurationIds'] == null ? undefined : json['configurationIds'],
        'remediateAll': json['remediateAll'] == null ? undefined : json['remediateAll'],
    };
}

export function MdmBootstrapFieldMismatchRemediateRequestToJSON(json: any): MdmBootstrapFieldMismatchRemediateRequest {
    return MdmBootstrapFieldMismatchRemediateRequestToJSONTyped(json, false);
}

export function MdmBootstrapFieldMismatchRemediateRequestToJSONTyped(value?: MdmBootstrapFieldMismatchRemediateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configurationIds': value['configurationIds'],
        'remediateAll': value['remediateAll'],
    };
}

